import RadarIcon from "@mui/icons-material/Radar";
import {
  PulseRing,
  PulseWrapper,
  RadarBadge,
} from "@modules/radar/shared/components/RadarPulseIcon/RadarPulseIcon.styles";

export const RadarPulseIcon = () => (
  <PulseWrapper>
    <PulseRing $delay="0s" />
    <PulseRing $delay="1.2s" />
    <RadarBadge>
      <RadarIcon fontSize="medium" />
    </RadarBadge>
  </PulseWrapper>
);
